// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "" + (chunkId === 76 ? "common" : chunkId) + "." + {"36":"70bd2014dc8d60b3","76":"ad42dca7e61b016c","331":"9ac2e17501ccc3cd","489":"1ee419bee5719ae1","995":"efd3fa70ff5bccbc"}[chunkId] + ".js";
};